export default "__VITE_ASSET__CBxspxSo__"